import { Button, Input, Modal } from "@/components/kit";
import type { CustomerRiskDTO } from "@/modules/customers/domain/types";
import { useState } from "react";
import { customerRiskTierMeta, formatDepositHint } from "./customer-risk";

type CodOverrideDialogProps = {
  open: boolean;
  risk: CustomerRiskDTO;
  onOpenChange: (open: boolean) => void;
  onConfirm: (reason: string) => void;
};

export function CodOverrideDialog({
  open,
  risk,
  onOpenChange,
  onConfirm,
}: CodOverrideDialogProps) {
  const [reason, setReason] = useState("");
  const meta = customerRiskTierMeta(risk.tier);
  const depositHint = formatDepositHint(risk);
  const reasonRequired = risk.tier === "prepaid_only";

  function handleConfirm() {
    const trimmed = reason.trim();
    if (reasonRequired && !trimmed) return;
    onConfirm(trimmed || "ຢືນຢັນ COD ເຖິງຄວາມສ່ຽງ");
    setReason("");
  }

  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        if (!next) setReason("");
        onOpenChange(next);
      }}
      title="ຢືນຢັນເລືອກ COD?"
      description={`${meta.actionLabel}${depositHint ? ` · ${depositHint}` : ""}`}
      size="sm"
      footer={
        <>
          <Button
            variant="outline"
            className="rounded-full"
            onClick={() => onOpenChange(false)}
          >
            ຍົກເລີກ
          </Button>
          <Button
            className="rounded-full"
            disabled={reasonRequired && !reason.trim()}
            onClick={handleConfirm}
          >
            ຢືນຢັນ COD
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <ul className="flex flex-col gap-1 text-muted-foreground text-sm">
          {risk.reasons.slice(0, 3).map((r) => (
            <li key={r}>· {r}</li>
          ))}
        </ul>
        <div className="flex flex-col gap-1.5">
          <label htmlFor="cod-override-reason" className="text-sm">
            ເຫດຜົນ{reasonRequired ? " *" : " (ຖ້າມີ)"}
          </label>
          <Input
            id="cod-override-reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="ເຊັ່ນ: ລູກຄ້າເກົ່າໃນຊຸມຊົນ / ຮູ້ຈັກສ່ວນຕົວ"
            autoFocus
          />
        </div>
      </div>
    </Modal>
  );
}
